import { Button, Popconfirm, Popover } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { useMutateProblemReports } from '@/store';

type Props = {
  problemReportId: string;
};

export const MoreActions: FC<Props> = ({ problemReportId }) => {
  const { t } = useTranslation('ProblemReportsTranslations');
  const { removeProblemReport, isWorking } = useMutateProblemReports();

  const handleDeleteProblemReport = () => removeProblemReport(problemReportId);

  return (
    <Popover
      trigger="click"
      content={
        <Popconfirm
          placement="top"
          onCancel={e => e?.stopPropagation()}
          onConfirm={e => {
            e?.stopPropagation();
            handleDeleteProblemReport();
          }}
          okText={t('DELETE')}
          cancelText={t('CANCEL')}
          title={t('DELETE_REPORT_CONFIRMATION')}>
          <Button
            block
            loading={isWorking}
            danger
            onClick={e => {
              e.stopPropagation();
            }}
            icon={<Icon i="TrashCan" />}>
            {t('DELETE_REPORT')}
          </Button>
        </Popconfirm>
      }>
      <Button
        type="text"
        onClick={e => e.stopPropagation()}
        icon={<Icon i="OverflowMenuVertical" />}
      />
    </Popover>
  );
};
